import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Github, Mail } from 'lucide-react';
import { contactInfo, FooterLinks } from '../../data/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-grid">
        {/* Company Info */}
        <div className="text-center">

          <div className="flex justify-center mb-4">
            <img
              src='/images/bottomlogo.webp'
              loading="eager"
              fetchpriority="high"
              alt="CXSquare Solutions"
              className="h-40 w-auto"
            />
          </div>

          <p className="body-md max-w-sm mx-auto mb-4">
            Customer Experience Squared
          </p>

          <div className="flex justify-center space-x-4">
            <a
              href={contactInfo.social.linkedin}
              className="w-10 h-10 rounded-lg bg-slate-800 hover:bg-blue-500 hover:text-white transition-all duration-200 flex items-center justify-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Linkedin className="h-5 w-5" />
            </a>

            <a
              href={contactInfo.social.twitter}
              className="w-10 h-10 rounded-lg bg-slate-800 hover:bg-blue-500 hover:text-white transition-all duration-200 flex items-center justify-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Twitter className="h-5 w-5" />
            </a>

            <a
              href={contactInfo.social.github}
              className="w-10 h-10 rounded-lg bg-slate-800 hover:bg-blue-500 hover:text-white transition-all duration-200 flex items-center justify-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Github className="h-5 w-5" />
            </a>
          </div>

        </div>


        {/* Product */}
        <div className="space-y-4">
          <h4 className="h4 text-white">Key Product Features</h4>
          <ul className="space-y-3">
            {FooterLinks.productSection.map((plan,i) => (
              <li key={i}><Link to={`/products/${plan.title}`} className="newbody-md text-slate-400 hover:text-green-400 transition-colors">{plan.title}</Link></li>
            ))}</ul>
        </div>

        {/* Solutions */}
        <div className="space-y-4">
          <h4 className="h4 text-white">Custom Solutions</h4>
          <ul className="space-y-3">
            {FooterLinks.solutionSection.map((plan,i) => (
              <li key={i}> <Link to={`/solutions/${plan.title}`} className="newbody-md text-slate-400 hover:text-green-400 transition-colors">{plan.title}</Link></li>
            ))}</ul>
        </div>

        {/* Company */}
        <div className="space-y-4">
          <h4 className="h4 text-white">Company</h4>
          <ul className="space-y-3">
            <li><Link to="about-us" className="newbody-md text-slate-400 hover:text-green-400 transition-colors">About Us</Link></li>
            <li><Link to="/contact" className="newbody-md text-slate-400 hover:text-green-400 transition-colors">Contact Us</Link></li>
            <li><Link to="/plans" className="newbody-md text-slate-400 hover:text-green-400 transition-colors">Plans</Link></li>
            <li><Link to="/demo" className="newbody-md text-slate-400 hover:text-green-400 transition-colors">Request Demo</Link></li>
            <li><Link to="/partner" className="newbody-md text-slate-400 hover:text-green-400 transition-colors">Become a Partner</Link></li>
            <li><Link to="/privacyPolicy" className="newbody-md text-slate-400 hover:text-green-400 transition-colors">Privacy Policy</Link></li>
            <li><Link to="/termsAndCondition" className="newbody-md text-slate-400 hover:text-green-400 transition-colors">Terms & Conditions</Link></li>
          </ul>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="mt-16 pt-8 border-t border-slate-800">
        <div className="container">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="body-sm text-slate-500">
              © {currentYear} CXSquare Solutions. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <div className="flex items-center space-x-2 text-slate-400">
                <Mail className="h-4 w-4" />
                <span className="body-sm">{contactInfo.email.general}</span>
              </div>
              {/* <div className="flex items-center space-x-2 text-slate-400">
                <Phone className="h-4 w-4" />
                <span className="body-sm">{contactInfo.addresses[0].phone}</span>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;